var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14V12.8249H3.10112C2.57678 12.8249 2.1573 12.4101 2.1573 11.788V9.24424C2.1573 8.66359 1.96255 8.19355 1.46816 8C1.96255 7.80645 2.1573 7.33641 2.1573 6.75576V4.19816C2.1573 3.57604 2.57678 3.17512 3.10112 3.17512H4V2H3.10112C1.88764 2 0.779026 2.84332 0.779026 4.21198V6.57604C0.779026 7.08756 0.524345 7.5023 0 7.5023V8.4977C0.524345 8.4977 0.779026 8.91244 0.779026 9.42396V11.8018C0.779026 13.1705 1.88764 14 3.10112 14H4ZM12 2V3.17511L12.8989 3.17511C13.4232 3.17512 13.8427 3.58986 13.8427 4.21198V6.75576C13.8427 7.33641 14.0375 7.80645 14.5318 8C14.0375 8.19355 13.8427 8.6636 13.8427 9.24424V11.8018C13.8427 12.424 13.4232 12.8249 12.8989 12.8249L12 12.8249V14H12.8989C14.1124 14 15.221 13.1567 15.221 11.788V9.42396C15.221 8.91244 15.4757 8.4977 16 8.4977V7.50231C15.4757 7.50231 15.221 7.08756 15.221 6.57604L15.221 4.19816C15.221 2.82949 14.1124 2 12.8989 2H12ZM6 8C6 8.54545 5.54545 9 5 9C4.45455 9 4 8.54545 4 8C4 7.45455 4.45455 7 5 7C5.54545 7 6 7.45455 6 8ZM8 9C8.54545 9 9 8.54545 9 8C9 7.45455 8.54545 7 8 7C7.45455 7 7 7.45455 7 8C7 8.54545 7.45455 9 8 9ZM12 8C12 8.54545 11.5455 9 11 9C10.4545 9 10 8.54545 10 8C10 7.45455 10.4545 7 11 7C11.5455 7 12 7.45455 12 8Z",
    fill: "#537089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeTagIcon);
export default __webpack_public_path__ + "static/media/merge-tag-icon.70be20b1b71ac6425a58cd268ab32c8c.svg";
export { ForwardRef as ReactComponent };